import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-collaboration-stepper',
  templateUrl: './collaboration-stepper.component.html',
  styleUrl: './collaboration-stepper.component.scss',
})
export class CollaborationStepperComponent {
  @Input() currentStep: number = 0;
}
